import { Center, Spinner } from "@chakra-ui/react";

export default function RingingCallsContentLoading() {
  return (
    <Center h="full">
      <Spinner size="xl" />
    </Center>
  );
}
